import { render, staticRenderFns } from "./circularFence.vue?vue&type=template&id=24ff58fe&scoped=true&"
import script from "./circularFence.vue?vue&type=script&lang=js&"
export * from "./circularFence.vue?vue&type=script&lang=js&"
import style0 from "./circularFence.vue?vue&type=style&index=0&id=24ff58fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ff58fe",
  null
  
)

export default component.exports